/**
 * Clip a polygon to one side of a line: the points where `f(p) <= 0`, `f`
 * being any function linear in the point (a signed distance or offset). One
 * Sutherland–Hodgman pass, so the result is right for a CONVEX polygon and for
 * any polygon the line crosses at most twice.
 *
 * Two passes make a band: the opening clearance zone clipped to the strip a
 * cabinet can reach (`kitchen-assembly/openingClearance.projectZoneToWallBlocker`),
 * a walkway clipped to a cabinet strip, a counter cut at an angled end
 * (`cabinet-runs/angledEnds.js`) or at a seam (`cabinet-runs/slabSeam.js`).
 *
 * Pure. No I/O.
 *
 * @param {Array<{x:number,z:number}>} poly
 * @param {(p:{x:number,z:number}) => number} f
 * @returns {Array<{x:number,z:number}>} the kept outline, possibly empty
 */
function clipToHalfPlane(poly, f) {
  const out = [];
  for (let i = 0; i < poly.length; i += 1) {
    const a = poly[i];
    const b = poly[(i + 1) % poly.length];
    const fa = f(a);
    const fb = f(b);
    if (fa <= 0) out.push(a);
    if ((fa < 0 && fb > 0) || (fa > 0 && fb < 0)) {
      const t = fa / (fa - fb);
      out.push({ x: a.x + (b.x - a.x) * t, z: a.z + (b.z - a.z) * t });
    }
  }
  return out;
}

module.exports = { clipToHalfPlane };
